

























import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import { Base, SurveyModel, Cover, CoverCell } from "survey-core";
import BaseVue from "../../base";

@Component
export class HeaderMobileViewModel extends Vue {
  @Prop() model: Cover;
  constructor(props: any) {
    super(props);
  }
}

Vue.component("sv-header-mobile", HeaderMobileViewModel);
export default HeaderMobileViewModel;
